export default __webpack_public_path__ + "static/media/prospect_list.e703e133.png";